import { CourierFilter, StoreTypeEnum } from "@saleor/types/globalTypes";

export default class AutoBookingConfig {
  readyStatusMinutes?: number | null;
  collectedStatusMinutes?: number | null;
  anyStatusMinutes?: number | null;
  storeType: StoreTypeEnum;
  courier: CourierFilter | null;
}

export class AutoBookingConfigForm {
  fbConfig: AutoBookingConfig;
  gmConfig: AutoBookingConfig;
}

export const AUTOBOOKING_LABELS = {
  FNB: "Food & Beverage",
  GM: "General Merchandise",
  GMSDD: "GM (SDD ONLY)",
  SHORT_FNB: "F&B",
  SHORT_GM: "GM"
};

export const ERROR_FIELDS = {
  ANY: "anyStatusMinutes",
  COLLECTED: "collectedStatusMinutes",
  COURIER: "courier",
  INPUT: "input",
  MALL: "mallId",
  READY: "readyStatusMinutes"
};
